// extracted by mini-css-extract-plugin
export default {"fav":"FavouriteButton-module__fav","active":"FavouriteButton-module__active","border":"FavouriteButton-module__border","icon":"FavouriteButton-module__icon"};